import { getPanelsOnPage } from './comicPages'
import type { ComicEpisode, ComicPage, ComicProject } from './comicTypes'

function pageHasGeneratableScript(panels: { script: string }[]): boolean {
  return panels.some((p) => p.script.trim().length > 0)
}

export function buildEpisodeGenerateJobPages(
  _project: ComicProject,
  episode: ComicEpisode,
  pages: ComicPage[],
): { pageIds: string[] } {
  const pageIds: string[] = []
  for (const page of pages) {
    const pagePanels = getPanelsOnPage(episode, page)
    if (!pageHasGeneratableScript(pagePanels)) continue
    pageIds.push(page.id)
  }

  return { pageIds }
}
